import FileResizer from 'react-image-file-resizer';
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg'];

export const compressImageFile = async (
  file: File,
  {
    maxHeight,
    minHeight,
    maxWidth,
    minWidth,
    quality
  }: {
    maxWidth: number;
    maxHeight: number;
    minWidth: number;
    minHeight: number;
    quality: number;
  }
) => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase?.();

  const isImageFile = IMAGE_EXTENSIONS.includes(fileExtension || '');

  if (!isImageFile) return file;

  const compressedFile = await new Promise((resolve) => {
    FileResizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      'JPEG',
      quality,
      0,
      resolve,
      'file',
      minWidth,
      minHeight
    );
  });

  return compressedFile as File;
};
